import { NgClass, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

export enum AccordionSubheaderState {
  Closing = 'closing',
  Opening = 'opening',
  Open = 'open',
  Closed = 'closed',
}

@Component({
  selector: 'lib-accordion-subheader',
  standalone: true,
  imports: [NgClass, NgStyle],
  templateUrl: './accordion-subheader.component.html',
  styleUrls: ['./accordion-subheader.component.scss'],
})
export class AccordionSubheaderLibComponent implements OnInit {
  @Input() id = '';
  @Input() header?: string;
  @Input() headerIcon?: string;
  @Input() subheader?: string;
  @Input() background: 'dark' | 'light' = 'light';
  @Input() foreground: 'dark' | 'light' = 'dark';
  @Input() startOpen = false;
  @Input() lastElementInThePage = false;
  @Input() smallContent = false;

  state = AccordionSubheaderState.Closed;
  active = false;
  expanded = false;

  ngOnInit(): void {
    this.expanded = this.startOpen;
    if (this.expanded) {
      this.state = AccordionSubheaderState.Open;
    }
  }

  toggle(): void {
    this.active = true;
    this.expanded = !this.expanded;
    this.state = this.expanded
      ? AccordionSubheaderState.Opening
      : AccordionSubheaderState.Closing;
  }

  onTransitionEnd(): void {
    this.state = this.expanded
      ? AccordionSubheaderState.Open
      : AccordionSubheaderState.Closed;
  }

  onBlur(): void {
    this.active = false;
  }
}